import Avatar from '@mui/material/Avatar';
import useProfilePictureSelectorStyles from './useProfilePictureSelectorStyles';

/**
 * Interface for the ProfilePictureSelector component
 * @param selectedPicture - the selected profile picture
 * @param onSelectPicture - the function to call when a profile picture is selected
 */
interface ProfilePictureSelectorProps {
  selectedPicture: string;
  onSelectPicture: (picture: string) => void;
}

/**
 * Component that allows the user to select a profile picture.
 * @param selectedPicture - the selected profile picture
 * @param onSelectPicture - the function to call when a profile picture is selected
 * @returns - the ProfilePictureSelector component
 */
const ProfilePictureSelector = ({
  selectedPicture,
  onSelectPicture,
}: ProfilePictureSelectorProps) => {
  const { classes } = useProfilePictureSelectorStyles();

  const profilePictures = [
    `profile1.png`,
    `profile2.png`,
    `profile3.png`,
    `profile4.png`,
    `profile5.png`,
  ];

  return (
    <div className={classes.profilePicSelector}>
      {profilePictures.map((picture, idx) => (
        <Avatar
          key={idx}
          src={`${process.env.PUBLIC_URL}/assets/profiles/${picture}`}
          alt={picture}
          className={
            selectedPicture === picture ? `${classes.selectedPic}` : `${classes.profilePic}`
          }
          onClick={() => onSelectPicture(picture)}
        />
      ))}
    </div>
  );
};

export default ProfilePictureSelector;
